/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: actions.ts
 * Class: actions.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { ActionTree } from 'vuex';
import axios, { AxiosResponse } from 'axios';
import { ProductResponse, ProductState } from './types';
import { RootState } from '../types';
import { ApiEndpointEnum, getApiRequestConfig } from '../../config/network';

export const actions: ActionTree<ProductState, RootState> = {
  fetchProduct({ commit }, payload: { productKey: string }): Promise<ProductResponse> {
    commit('orderProductLoading');

    return new Promise((resolve, reject) => {
      this.state.$http(`orderProduct?productKey=${payload.productKey}`,
        getApiRequestConfig(ApiEndpointEnum.ProductAPI))
        .then((response: AxiosResponse<ProductResponse>) => {
          const product: ProductResponse = response && response.data;
          commit('orderProductLoaded', product);
          resolve(product);
        }, (error) => {
          commit('orderProductFailure');
          reject(error);
        }).catch((error) => {
          commit('orderProductFailure');
          reject(error);
        });
    });
  },
};
